import React, { lazy } from 'react';
import authRoles from '../../../auth/authRoles';

const ShowQrCode = lazy(() => import('@ameroservices-platform/loppe-boothownerui/app/main/apps/qrCode/ShowQrCode'));

const QRCodeAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.user,
	routes: [
		{
			path: '/qr',
			element: <ShowQrCode />
		}
	]
};

export default QRCodeAppConfig;
